/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import {Option} from '../../models/Sektor'
import {radniNaloziOdjeli} from '../../api/fmkNalozi'

// skladisteRepromaterijala Dropdown Props for the component
interface DropdownProps {
  value?: string | number
  initialValue?: string | number
  onChange?: (name: string, value: any) => void
  errors?: string | undefined
  touched?: boolean
  selectName?: string
}

const RadniNaloziOdjeliDropdown: React.FC<DropdownProps> = ({
  value,
  initialValue,
  onChange,
  errors,
  touched,
  selectName,
}) => {
  const [RadniNaloziOdjeliDropdown, setRadniNaloziOdjeliDropdown] = useState<Array<Option>>([])
  const internalValue = initialValue ?? null

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await radniNaloziOdjeli()
        setRadniNaloziOdjeliDropdown(mapData(response.data))
      } catch (error) {
        console.error('Error fetching Odjel dropdown data:', error)
      }
    }
    fetchData()
  }, [])

  const finalValue = value ?? internalValue

  const mapData = (data) => {
    if (!data) {
      return []
    }
    return data.map((item) => ({label: item.Naziv, value: item.Id.toString()}))
  }

  return (
    <SearchableSelect
      options={RadniNaloziOdjeliDropdown}
      value={finalValue?.toString() ?? ''}
      onChange={onChange!}
      name={selectName ?? 'RadniNaloziOdjeliDropdown'}
      errors={errors}
      placeholder='Odaberi Odjeli.'
      touched={touched}
    />
  )
}

export default RadniNaloziOdjeliDropdown
